/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginUserRequest
 */
export interface LoginUserRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginUserRequest
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserRequest
     */
    loginToken: string;
}

export function LoginUserRequestFromJSON(json: any): LoginUserRequest {
    return LoginUserRequestFromJSONTyped(json, false);
}

export function LoginUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pin': !exists(json, 'pin') ? undefined : json['pin'],
        'loginToken': json['login_token'],
    };
}

export function LoginUserRequestToJSON(value?: LoginUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pin': value.pin,
        'login_token': value.loginToken,
    };
}


